export default "__VITE_PUBLIC_ASSET__cbb0111a__"